import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';
import NinthAgeUnitV2Make from '@Components/survey/NinthAgeUnitV2Make/NinthAgeUnitV2Make';

const ToolSurveyUnitPageMake: React.FC<ToolSurveyUnitPageMakeProps> = ({ isLoading, loadUnit }) => {

  React.useEffect(() => {
    loadUnit()
  }, []);

  if(isLoading)
  return <div className="loader"></div>

  return <section>
    <div className="text-center mt-5">
      <h1>What is the right cost for you?</h1>
      <p>Answer the following survey to find out.</p>
      <p>It will take you about 5 minutes.</p>
    </div>

    <NinthAgeUnitV2Make/>
  </section>
};

const mapStateToProps = (state: AppState) => ({
  isLoading: false
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    loadUnit: () => {}
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ToolSurveyUnitPageMake);

type ToolSurveyUnitPageMakeProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>